export default __webpack_public_path__ + "static/media/Line.d60af38f.svg";